export function money(v: string | number | null | undefined, ccy: string, opts: { sign?: boolean; dp?: number } = {}): string {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  const s = n.toLocaleString(undefined, { minimumFractionDigits: opts.dp ?? 2, maximumFractionDigits: opts.dp ?? 2 });
  const sym = ccy === 'EUR' ? '€' : ccy === 'USD' ? '$' : ccy === 'GBP' ? '£' : `${ccy} `;
  const sign = opts.sign && n > 0 ? '+' : '';
  return n < 0 ? `−${sym}${s.replace('-', '')}` : `${sign}${sym}${s}`;
}
export function pct(v: number | null | undefined, dp = 1): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return '—';
  return `${v > 0 ? '+' : ''}${(v * 100).toFixed(dp)}%`;
}
export function when(iso: string | null | undefined, now = new Date()): string {
  if (!iso) return '—';
  const d = new Date(iso);
  const diff = d.getTime() - now.getTime();
  const abs = Math.abs(diff);
  if (abs < 60_000) return diff <= 0 ? 'just now' : 'in a moment';
  if (abs < 3600_000) return diff < 0 ? `${Math.round(abs / 60_000)} min ago` : `in ${Math.round(abs / 60_000)} min`;
  if (abs < 86_400_000) return diff < 0 ? `${Math.round(abs / 3600_000)} h ago` : `in ${Math.round(abs / 3600_000)} h`;
  return d.toLocaleString(undefined, { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}
export function absTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}
export function stanceGlyph(s: string | null | undefined): string {
  switch (s ?? 'UNCHANGED') {
    case 'STRENGTHENED': return '↗';
    case 'WEAKENED': return '↘';
    case 'INVALIDATED': return '◯';
    case 'INITIAL': return '•';
    default: return '→';
  }
}
export function titleCase(s: string): string {
  return s.toLowerCase().replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}
